import Vue from 'vue'
import store from '@/store'
import FilterService from '@/service/filter/FilterService'

Vue.directive('bankName', {
  update(el, binding, vnode) {
    let inputBankCode = Number(vnode.data.model.value)
    let banks = store.getters['filter/getBanks']
    let filteredBank = ''

    if (!banks) {
      FilterService.setBanks()
    } else {
      banks.some(bank => {
        if (Number(bank.bankCode) === inputBankCode) {
          filteredBank = bank.bankName
          return true
        }
      })
    }
    el.value = filteredBank
  }
})
